module.exports = __webpack_public_path__ + "static/media/michelin.46a40ee5.jpg";